module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/lipBalms@2x_838875.jpg";